import React, { useState, useEffect, useRef } from "react";
import "./NavItem.css";

function NavItem({ navTitle, navIcon, navLink, selected}) {
  return (
    <a href={navLink} className='sub-header-nav-item-link'>
      <div className={`sub-header-nav-item ${selected ? "selected" : ""}`}>
        <i className={navIcon}></i>
        <p>{navTitle}</p>
      </div>
    </a>
  );
}

export default NavItem;
